// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sidebar {
  width: 260px;
  background-color: var(--bg-header-sidebar);
  color: #d1d5db;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar-header {
  padding: 1.5rem 1rem 1rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
}

.sidebar-header h2 {
  margin: 0;
  font-size: 18px;
  color: var(--color-sidebar);
}

.sidebar-user {
  display: flex;
  align-items: center;
  padding: 1rem;
}

.user-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 0.75rem;
}

.user-info .username {
  font-size: 14px;
  margin: 0;
  color: #fff;
}

.sidebar-buttons {
  padding: 1rem;
}

.sidebar-buttons button {
  width: 100%;
  padding: 0.75rem;
  background-color: #3b3c47;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 0.5rem;
  font-size: 14px;
}

.sidebar-buttons button:hover {
  background-color: #4b4c57;
}

.sidebar-section {
  padding: 1rem;
  flex: 1 1;
  overflow-y: auto;
}

.sidebar-section-title {
  margin: 0 0 0.5rem 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-sidebar);
}

.example-btn {
  display: block;
  width: 100%;
  padding: 0.6rem;
  background-color: var(--bg-sidebar-button);
  color: var(--color-sidebar);
  border: 1px solid var(--color-border-button);
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  margin-bottom: 0.5rem;
  font-size: 14px;
}

.example-btn:hover {
  background-color: var(--bg-sidebar-button-hover);
}

.refer-earn-btn {
  background-color: #ffd180;
  border: 1px solid var(--color-border-button);
  color: var(--color-sidebar);
  width: 100%;
  border-radius: 8px;
  padding: 12px 15px; /* same as new-chat-button for consistent height */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;  /* ensure vertical alignment */
  transition: background 0.3s ease;
}

.refer-earn-btn:hover {
  background-color: var(--bg-sidebar-button-hover);
}


.sidebar-footer {
  padding: 1rem;
  font-size: 11px;
  color: #777;
}

@media screen and (max-width: 768px) {
  .sidebar {
    width: 260px;
  }

  .sidebar-header h2 {
    font-size: 16px;
  }

  .sidebar-user {
    flex-direction: column;
    align-items: center;
    padding: 0.75rem;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
    margin-right: 0;
    margin-bottom: 0.5rem;
  }

  .user-info .username {
    font-size: 12px;
    text-align: center;
  }

  .sidebar-buttons {
    padding: 0.75rem;
  }

  .sidebar-buttons button {
    padding: 0.5rem;
    font-size: 12px;
  }

  .sidebar-section {
    padding: 0.75rem;
  }

  .sidebar-section-title {
    font-size: 12px;
  }

  .example-btn {
    padding: 0.7rem;
    font-size: 13px;
    font-weight: 500;
  }

  .sidebar-footer {
    padding: 0.75rem;
    font-size: 10px;
  }
}

@media screen and (max-width: 768px) {
  .sidebar-container {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 1000;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }

  .sidebar-container.open {
    transform: translateX(0);
  }

  .sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.5);
    z-index: 900;
  }

  .sidebar-toggle-button {
    position: fixed;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
    background-color: #202123;
    color: #fff;
    padding: 5px;
    border-radius: 0 5px 5px 0;
    cursor: pointer;
    z-index: 1100;
  }
}

.new-chat-section {
  width: 100%;
  height: auto;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.new-chat-button-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 85%;
  height: auto;
  gap: 12px;
}

.new-chat-button {
  background-color: var(--bg-sidebar-button);
  border: 1px solid var(--color-border-button);
  color: var(--color-sidebar);
  width: 100%;
  border-radius: 8px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

.new-chat-button:hover {
  background-color: var(--bg-sidebar-button-hover);
}

`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,2BAA2B;EAC3B,4CAA4C;EAC5C,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,kBAAkB,EAAE,kDAAkD;EACtE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB,GAAG,8BAA8B;EACjD,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;AAClD;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,iCAAiC;IACjC,YAAY;EACd;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,OAAO;IACP,gCAAgC;IAChC,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,gDAAgD;AAClD","sourcesContent":["\n.sidebar {\n  width: 260px;\n  background-color: var(--bg-header-sidebar);\n  color: #d1d5db;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.sidebar-header {\n  padding: 1.5rem 1rem 1rem 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 0;\n}\n\n.sidebar-header h2 {\n  margin: 0;\n  font-size: 18px;\n  color: var(--color-sidebar);\n}\n\n.sidebar-user {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n}\n\n.user-avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  margin-right: 0.75rem;\n}\n\n.user-info .username {\n  font-size: 14px;\n  margin: 0;\n  color: #fff;\n}\n\n.sidebar-buttons {\n  padding: 1rem;\n}\n\n.sidebar-buttons button {\n  width: 100%;\n  padding: 0.75rem;\n  background-color: #3b3c47;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-bottom: 0.5rem;\n  font-size: 14px;\n}\n\n.sidebar-buttons button:hover {\n  background-color: #4b4c57;\n}\n\n.sidebar-section {\n  padding: 1rem;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.sidebar-section-title {\n  margin: 0 0 0.5rem 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-sidebar);\n}\n\n.example-btn {\n  display: block;\n  width: 100%;\n  padding: 0.6rem;\n  background-color: var(--bg-sidebar-button);\n  color: var(--color-sidebar);\n  border: 1px solid var(--color-border-button);\n  border-radius: 10px;\n  cursor: pointer;\n  text-align: left;\n  margin-bottom: 0.5rem;\n  font-size: 14px;\n}\n\n.example-btn:hover {\n  background-color: var(--bg-sidebar-button-hover);\n}\n\n.refer-earn-btn {\n  background-color: #ffd180;\n  border: 1px solid var(--color-border-button);\n  color: var(--color-sidebar);\n  width: 100%;\n  border-radius: 8px;\n  padding: 12px 15px; /* same as new-chat-button for consistent height */\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.4;  /* ensure vertical alignment */\n  transition: background 0.3s ease;\n}\n\n.refer-earn-btn:hover {\n  background-color: var(--bg-sidebar-button-hover);\n}\n\n\n.sidebar-footer {\n  padding: 1rem;\n  font-size: 11px;\n  color: #777;\n}\n\n@media screen and (max-width: 768px) {\n  .sidebar {\n    width: 260px;\n  }\n\n  .sidebar-header h2 {\n    font-size: 16px;\n  }\n\n  .sidebar-user {\n    flex-direction: column;\n    align-items: center;\n    padding: 0.75rem;\n  }\n\n  .user-avatar {\n    width: 40px;\n    height: 40px;\n    margin-right: 0;\n    margin-bottom: 0.5rem;\n  }\n\n  .user-info .username {\n    font-size: 12px;\n    text-align: center;\n  }\n\n  .sidebar-buttons {\n    padding: 0.75rem;\n  }\n\n  .sidebar-buttons button {\n    padding: 0.5rem;\n    font-size: 12px;\n  }\n\n  .sidebar-section {\n    padding: 0.75rem;\n  }\n\n  .sidebar-section-title {\n    font-size: 12px;\n  }\n\n  .example-btn {\n    padding: 0.7rem;\n    font-size: 13px;\n    font-weight: 500;\n  }\n\n  .sidebar-footer {\n    padding: 0.75rem;\n    font-size: 10px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .sidebar-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    z-index: 1000;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n  }\n\n  .sidebar-container.open {\n    transform: translateX(0);\n  }\n\n  .sidebar-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0,0,0,0.5);\n    z-index: 900;\n  }\n\n  .sidebar-toggle-button {\n    position: fixed;\n    top: 50%;\n    left: 0;\n    transform: translate(-50%, -50%);\n    background-color: #202123;\n    color: #fff;\n    padding: 5px;\n    border-radius: 0 5px 5px 0;\n    cursor: pointer;\n    z-index: 1100;\n  }\n}\n\n.new-chat-section {\n  width: 100%;\n  height: auto;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.new-chat-button-container {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  width: 85%;\n  height: auto;\n  gap: 12px;\n}\n\n.new-chat-button {\n  background-color: var(--bg-sidebar-button);\n  border: 1px solid var(--color-border-button);\n  color: var(--color-sidebar);\n  width: 100%;\n  border-radius: 8px;\n  padding: 0 15px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n}\n\n.new-chat-button:hover {\n  background-color: var(--bg-sidebar-button-hover);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
